
import { Component,  Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';

@Component
export default class BroadcastsEventsMethods extends Vue {
    public hasUnreadComments: boolean = false;
    public tabs: any = [];
    public activeTab: string = '';
    public activeComponent: string = '';

    get commentsConversation() {
        return this.$store.getters['Comments/getComments'];
    }

    get commentsLoaded() {
        return this.$store.getters['Comments/getCommentsDataLoaded'];
    }

    get commentsCount() {
        return this.commentsConversation !== null ? this.commentsConversation.comments.length : 0;
    }

    public changeActiveComponent(tab: string) {
        const selectedTab = this.tabs.find((tabObj: any) => tabObj.value === tab);

        this.activeTab       = tab;
        this.activeComponent = selectedTab.component;

        if (tab === 'comments') {
            if (!this.commentsConversation) {
                return;
            }

            if (this.commentsConversation.comments.length) {
                const lastMessage = Math.max.apply(Math, this.commentsConversation.comments.map((comment: any) => comment.id));

                this.$store.dispatch(Actions.MARK_COMMENT_AS_SEEN, {
                    conversationId: this.commentsConversation.id,
                    lastMessageId: lastMessage,
                });

                this.hasUnreadComments = false;
                this.configureCommentsTabBadge();
            }

            Vue.nextTick(() => {
                this.scrollToBottom('broadcast-comments');
            });
        }
    }

    public configureCommentsTabBadge() {}

    public scrollToBottom(id: string): void {
        Vue.nextTick(() => {
            const scrollElement = document.getElementById(id);

            if (scrollElement) {
                scrollElement.scrollTo(0, scrollElement.scrollHeight);
            }
        });
    }
}
